// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components----referenceSlider-module---container---G9nw2","slider":"src-components----referenceSlider-module---slider---18VBG","sliderTitle":"src-components----referenceSlider-module---sliderTitle---1eSyj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/referenceSlider.module.scss
// module id = 434
// module chunks = 35783957827783